<template>
    <div class="flip">
        <div
            class="card"
            :class="{'card-flipped' : flipped }"
        >
            <div
                :id="'child-front-' + child.id + '-' + category"
                class="child-front"
            >
                <div
                    v-if="statusNotHereYet"
                    class="info-btn btn-absent"
                    @click="showAbsentLayer = !showAbsentLayer"
                >
                    <i class="icon-ban"></i>
                </div>

                <div
                    class="info-btn btn-pickuppermissions"
                    @click="showPickupPermissions()"
                >
                    <i class="icon-users2"></i>
                </div>

                <div
                    v-if="!statusAbsent"
                    class="btn-turn-around"
                    @click="flipped = true"
                >
                    <i class="icon-reply-all"></i>
                </div>
                <div class="card-content">
                    <h3>{{ child.firstname }}<br />{{ child.lastname }}</h3>
                    <div
                        v-if="child.description"
                        class="infoIcon"
                        @click="flipped = true"
                    >
                        <i class="icon-info important"></i>
                    </div>
                    <kgr-tablet-view-child-medical-info
                        :status-is-present="statusIsPresent"
                        :medical-special-info="child.medicalSpecialInfo"
                        :drug-info="child.drugInfo"
                        :nutrition-info="child.nutritionInfo"
                        :medical-info="child.medicalInfo"
                    />
                    <div class="child-image">
                        <div
                            class="child-image-container"
                            :class="{'greyed-out': greyedOut }"
                            :style="imageBackground "
                        ></div>
                        <div
                            v-if="showAbsentLayer"
                            class="absent text-left"
                        >
                            <div
                                class="absentSave"
                                @click="isSick()"
                            >
                                <i class="icon-medkit"></i>
                                <span>{{ $t('child_checkin_status_illness') }}</span>
                            </div>
                            <div
                                class="absentSave"
                                @click="inVacation()"
                            >
                                <i class="icon-plane"></i>
                                <span>{{ $t('child_checkin_status_vacation') }}</span>
                            </div>
                            <div
                                class="absentSave"
                                @click="isAbsentOthers()"
                            >
                                <i class="icon-ban"></i>
                                <span>{{ $t('Sonstiges') }}</span>
                            </div>
                            <div
                                class="absentSave"
                                @click="isAbsentWithoutExcuse()"
                            >
                                <i class="icon-question"></i>
                                <span>{{ $t('child_checkin_status_without_excuse') }}</span>
                            </div>
                        </div>
                        <div
                            v-if="statusAbsent"
                            class="absentInfo"
                        >
                            <span v-if="child.absenceType === 'illness'">
                                <i class="icon-medkit"></i><br />
                                {{ $t('child_checkin_status_illness') }}
                                <span
                                    v-if="child.notifiableDisease"
                                    :title="child.notifiableDisease"
                                >
                                    <i class="icon-warning"></i>
                                </span>
                            </span>
                            <span v-else-if="child.absenceType === 'vacation'">
                                <i class="icon-plane"></i><br />
                                {{ $t('child_checkin_status_vacation') }}
                            </span>
                            <span v-else-if="child.absenceType === 'other'">
                                <i class="icon-ban"></i><br />
                                {{ $t('Sonstiges') }}
                            </span>
                            <span v-else>
                                <i class="icon-question"></i><br />
                                {{ $t('child_checkin_status_without_excuse') }}
                            </span>
                            <div
                                v-if="child.isAbsenceDeletable"
                                class="delete-absence"
                                :title="$t('child_checkin_info_delete_absence')"
                                @click="deleteCurrentAbsence()"
                            >
                                <i class="icon-trash-o"></i>
                            </div>
                            <div
                                v-else
                                class="delete-absence"
                                :title="$t('child_checkin_info_delete_absence_notpossible')"
                            >
                                <i class="icon-trash-o delete-absence-trans"></i>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card-footer">
                    <div v-if="categoryCheckin">
                        <a
                            class="btn btn-default btn-lg btn-block btn-raised"
                            :class="{ 'btn-press': canBeLoggedIn, 'btn-dontpress': !canBeLoggedIn, 'but-two-lines': hasStatus('absent'), 'greyed-out': statusIsPresent && !attendanceCanBeDeleted }"
                            @click="(statusIsPresent ? deleteAttendance() : checkInNow())"
                        >
                            <div v-if="statusIsPresent">{{ $t('child_checkin_but_butNotHere') }}</div>
                            <div v-else-if="statusAbsent">
                                {{ $t('Ist jetzt da') }}<br />
                                <span class="but-hint">{{ $t('child_checkin_but_isNowThere_hint') }}</span>
                            </div>
                            <div v-else>
                                {{ $t('Ist jetzt da') }}
                            </div>
                        </a>
                    </div>
                    <div v-else>
                        <a
                            class="btn btn-default btn-lg btn-block btn-raised"
                            :class="{ 'btn-press': canBeLoggedOut, 'btn-dontpress': !canBeLoggedOut }"
                            @click="(statusPickedUp ? deleteCheckoutTime() : checkoutNow())"
                        >
                            <div v-if="statusPickedUp">{{ $t('child_checkin_but_isStillThere') }}</div>
                            <div v-else>{{ $t('Geht jetzt') }}</div>
                        </a>
                    </div>
                </div>
            </div>

            <div
                :id="'child-back-' + child.id +'-' + category"
                class="child-back"
            >
                <div
                    class="btn-turn-around"
                    @click="flipped = false"
                >
                    <i class="icon icon-reply-all rot180"></i>
                </div>
                <div class="card-content">
                    <h3>{{ child.firstname }}<br />{{ child.lastname }}</h3>
                    <div
                        v-if="child.hasRegularTime"
                        v-html="$t('child_checkin_regular_times', {'start': child.regularTimeStart, 'end': child.regularTimeEnd })"
                    ></div>
                    <div
                        v-else
                        v-html="$t('child_checkin_regular_times_missing')"
                    ></div>
                    <div v-if="categoryCheckin">
                        <label>{{ $t('child_checkin_label_arrival') }}
                            <kgr-time-picker
                                class="input-time"
                                :class="{'has-errors': !isValidTime}"
                                :value="child.checkinTime"
                                @change="updateCheckinTime($event.toString())"
                                @error="isValidTime=false"
                            />
                        </label>
                    </div>
                    <div v-else>
                        <label>{{ $t('child_checkin_label_went') }}
                            <kgr-time-picker
                                class="input-time"
                                :class="{'has-errors': !isValidTime}"
                                :value="child.checkoutTime"
                                @change="updateCheckoutTime($event.toString())"
                                @error="isValidTime=false"
                            />
                        </label>
                    </div>
                    <label>{{ $t('child_checkin_label_info') }}
                        <textarea
                            v-model="child.description"
                            class="attendance-time-info"
                            name="description"
                            @change="changeDescription()"
                        ></textarea>
                    </label>
                </div>
                <div class="card-footer">
                    <div v-if="categoryCheckin">
                        <a
                            class="btn btn-default btn-lg btn-block btn-raised"
                            :class="{ 'btn-press': canBeLoggedIn, 'btn-dontpress': !canBeLoggedIn }"
                            @click="( statusIsPresent ? change('checkin') : checkIn())"
                        >
                            <span v-if="!statusIsPresent">{{ $t('Speichern') }}</span>
                            <span v-if="statusIsPresent">{{ $t('child_checkin_but_change') }}</span>
                        </a>
                    </div>
                    <div v-else>
                        <a
                            class="btn btn-default btn-lg btn-block btn-raised"
                            :class="{ 'btn-press': canBeLoggedOut, 'btn-dontpress': !canBeLoggedOut }"
                            @click="(statusPickedUp ? change('checkout') : checkOut())"
                        >
                            <span v-if="!statusPickedUp">{{ $t('Speichern') }}</span>
                            <span v-if="statusPickedUp">{{ $t('child_checkin_but_change') }}</span>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import AppTabletViewChildMedicalInfo from './TabletViewChildMedicalInfo';
import EventBus from '../../js/service/EventBus.js';
import TimePicker from '../common/form/picker/TimePicker.vue';
import moment from 'moment';

export default {
    components: {
        'kgr-tablet-view-child-medical-info': AppTabletViewChildMedicalInfo,
        'kgr-time-picker': TimePicker,
    },
    props: {
        child: {
            type: Object,
            required: true,
        },
        category: {
            type: String,
            required: true,
        },
        errorCallback: {
            type: Function,
            required: true,
        }
    },
    data() {
        return {
            flipped: false,
            showAbsentLayer: false,
            isValidTime: true,
        }
    },
    computed: {
        imageBackground() {
            return 'background-image: url(' + this.child.image + ')';
        },
        statusPickedUp() {
            return this.hasStatus('pickedUp');
        },
        statusIsPresent() {
            return this.hasStatus('present');
        },
        statusNotHereYet() {
            return this.hasStatus('notHereYet');
        },
        statusAbsent() {
            return this.hasStatus('absent');
        },
        categoryCheckin() {
            return this.category === 'checkin';
        },
        canBeLoggedIn() {
            return !!(this.statusPickedUp || this.statusNotHereYet);
        },
        greyedOut() {
            return (!this.statusIsPresent);
        },
        canBeLoggedOut() {
            return !!this.statusIsPresent;
        },
        attendanceCanBeDeleted() {
            return this.child.attendanceId;
        },
    },
    mounted() {
        EventBus.$on('reset_tablet_view', () => this.flipped = false);
        if (this.localStorageKeyExists('checkin_updateDescription')) {
            localStorage.removeItem('checkin_updateDescription');
        }
    },
    methods: {
        showPickupPermissions() {
            this.$emit('show-pickup-permission', this.child);
        },
        hasStatus(status) {
            return $.inArray(status, this.child.status) !== -1;
        },
        addStatus(status) {
            this.child.status.push(status);
        },
        removeStatus(status) {
            this.child.status.splice($.inArray(status, this.child.status), 1);
        },
        toggleStatus(status) {
            if (this.hasStatus(status)) {
                this.removeStatus(status);
            } else {
                this.addStatus(status);
            }
        },
        deleteStatus(status) {
            if (this.hasStatus(status)) {
                this.removeStatus(status);
            }
        },
        clone(obj) {
            return JSON.parse(JSON.stringify(obj));
        },
        getCurrentClock() {
            let date = new Date;
            let m = date.getMinutes();
            let h = date.getHours();
            return ('0' + h).slice(-2) + ':' + ('0' + m).slice(-2);
        },
        checkIn() {
            this.flipped = false;
            this.$emit('hide-pickup-permission');
            this.showAbsentLayer = false;
            let oldChild = this.clone(this.child);
            this.child.updateCheckinTimer = false;
            this.deleteStatus('notHereYet');
            this.addStatus('present');
            this.deleteStatus('absent');
            this.call_checkIn(oldChild);
        },
        checkInNow() {
            this.$emit('hide-pickup-permission');
            let oldChild = this.clone(this.child);
            this.flipped = false;
            this.child.checkinTime = this.getCurrentClock();
            this.child.updateCheckinTimer = false;
            this.deleteStatus('notHereYet');
            this.deleteStatus('absent');
            this.toggleStatus('present');
            this.call_checkIn(oldChild);
        },
        deleteAttendance() {
            if (!this.attendanceCanBeDeleted) {
                return;
            }
            this.$emit('hide-pickup-permission');
            let oldChild = this.clone(this.child);
            this.toggleStatus('present');
            if (this.child.isAbsent) {
                this.addStatus('absent');
            } else {
                this.toggleStatus('notHereYet');
            }
            this.child.checkinTime = this.child.hasRegularTime ? this.child.regularTimeStart : this.getNowFormated();
            this.child.updateCheckinTimer = !this.child.hasRegularTime;
            this.flipped = false;
            this.call_deleteAttendance(oldChild);
        },
        getNowFormated() {
            let today = new Date();
            let hours = ('0' + today.getHours()).slice(-2);
            let minutes = ('0' + today.getMinutes()).slice(-2);
            return hours + ':' + minutes;
        },
        localStorageKeyExists(localStorageKey) {
            return localStorage.getItem(localStorageKey) !== null;
        },
        call_checkIn(oldChild) {
            let url = `/backend/checkin/${this.child.id}/checkin`;
            let dataToSend = {
                description: this.child.description,
                checkinTime: this.child.checkinTime,
                source: 'tablet_view'
            };
            let now = Date.now();
            let end = now + 100; // wait 100 Milliseconds
            while (this.localStorageKeyExists('checkin_updateDescription') && now < end) {
                now = Date.now();
            }

            localStorage.setItem('checkin_update', true);
            $.post(
                url,
                dataToSend,
                data => {
                    this.$emit('update-attendance', {id: oldChild.id, attendanceId: data.attendanceId});
                    localStorage.removeItem('checkin_update');
                },
            ).fail((xhr, status, error) => {
                this.handle_ajax_error(xhr, status, error, oldChild);
                localStorage.removeItem('checkin_update');
            });
        },
        call_childAbsent(oldChild, status) {
            localStorage.setItem('checkin_update', true);
            $.post(
                '/backend/child/attendance-times/action',
                {'child': this.child.id, 'action': status},
                () => {
                    localStorage.removeItem('checkin_update');
                },
            ).fail((xhr, status, error) => {
                this.handle_ajax_error(xhr, status, error, oldChild);
                localStorage.removeItem('checkin_update');
            });
        },
        call_deleteCurrentAbsence(oldChild) {
            localStorage.setItem('checkin_update', true);
            $.post(
                `/backend/checkin/${this.child.id}/deleteCurrentAbsence`,
                () => {
                    localStorage.removeItem('checkin_update');
                },
            ).fail((xhr, status, error) => {
                this.handle_ajax_error(xhr, status, error, oldChild);
                localStorage.removeItem('checkin_update');
            });
        },
        call_deleteCheckoutTime(oldChild) {
            localStorage.setItem('checkin_update', true);
            $.post(
                `/backend/checkin/${this.child.attendanceId}/deleteCheckoutTime`,
                () => {
                    localStorage.removeItem('checkin_update');
                },
            ).fail((xhr, status, error) => {
                this.handle_ajax_error(xhr, status, error, oldChild);
                localStorage.removeItem('checkin_update');
            });
        },
        call_checkoutNow(oldChild) {
            localStorage.setItem('checkin_update', true);
            $.post(
                `/backend/checkin/${this.child.attendanceId}/checkout_now`,
                {description: this.child.description},
                () => {
                    localStorage.removeItem('checkin_update');
                },
            ).fail((xhr, status, error) => {
                this.handle_ajax_error(xhr, status, error, oldChild);
                localStorage.removeItem('checkin_update');
            });
        },
        call_checkout(oldChild) {
            localStorage.setItem('checkin_update', true);
            $.post(
                `/backend/checkin/${this.child.attendanceId}/checkout`,
                {description: this.child.description, checkoutTime: this.child.checkoutTime},
                () => {
                    localStorage.removeItem('checkin_update');
                },
            ).fail((xhr, status, error) => {
                this.handle_ajax_error(xhr, status, error, oldChild);
                localStorage.removeItem('checkin_update');
            });
        },
        call_change(oldChild, action) {
            localStorage.setItem('checkin_update', true);
            $.post(
                `/backend/checkin/${this.child.attendanceId}/change`,
                {
                    'checkinTime': this.child.checkinTime,
                    'checkoutTime': this.child.checkoutTime,
                    'action': action,
                    'description': this.child.description,
                    'source': 'tablet_view_change',
                },
                () => {
                    localStorage.removeItem('checkin_update');
                },
            ).fail((xhr, status, error) => {
                this.handle_ajax_error(xhr, status, error, oldChild);
                EventBus.$emit('reset_tablet_view');
                localStorage.removeItem('checkin_update');
            });
        },
        call_deleteAttendance(oldChild) {
            localStorage.setItem('checkin_update', true);
            $.post(
                `/backend/checkin/${this.child.attendanceId}/deleteAttendance`,
                () => {
                    localStorage.removeItem('checkin_update');
                },
            ).fail((xhr, status, error) => {
                this.handle_ajax_error(xhr, status, error, oldChild);
                EventBus.$emit('reset_tablet_view');
                localStorage.removeItem('checkin_update');
            });
        },
        call_updateDescription(oldChild, today) {
            localStorage.setItem('checkin_updateDescription', 'true');
            $.post(
                `/backend/checkin/${this.child.id}/updateDescription`,
                {
                    'description': this.child.description,
                    'date': today,
                },
                () => {
                    localStorage.removeItem('checkin_updateDescription');
                },
            ).fail((xhr, status, error) => {
                let oldChild = this.clone(this.child);
                this.handle_ajax_error(xhr, status, error, oldChild);
                EventBus.$emit('reset_tablet_view');
                localStorage.removeItem('checkin_updateDescription');
            });
        },
        isSick() {
            this.$emit('hide-pickup-permission');
            let oldChild = this.clone(this.child);
            this.deleteStatus('notHereYet');
            this.deleteStatus('present');
            this.addStatus('absent');
            this.showAbsentLayer = false;
            this.child.absenceType = 'illness';
            this.child.isAbsenceDeletable = true;
            this.call_childAbsent(oldChild, 'illness');
        },
        inVacation() {
            this.$emit('hide-pickup-permission');
            let oldChild = this.clone(this.child);
            this.deleteStatus('notHereYet');
            this.deleteStatus('present');
            this.addStatus('absent');
            this.showAbsentLayer = false;
            this.child.absenceType = 'vacation';
            this.child.isAbsenceDeletable = true;
            this.call_childAbsent(oldChild, 'vacation');
        },
        isAbsentOthers() {
            this.$emit('hide-pickup-permission');
            let oldChild = this.clone(this.child);
            this.deleteStatus('notHereYet');
            this.deleteStatus('present');
            this.addStatus('absent');
            this.showAbsentLayer = false;
            this.child.absenceType = 'other';
            this.child.isAbsenceDeletable = true;
            this.call_childAbsent(oldChild, 'other');
        },
        isAbsentWithoutExcuse() {
            this.$emit('hide-pickup-permission');
            let oldChild = this.clone(this.child);
            this.deleteStatus('notHereYet');
            this.deleteStatus('present');
            this.addStatus('absent');
            this.showAbsentLayer = false;
            this.child.absenceType = 'without_excuse';
            this.child.isAbsenceDeletable = true;
            this.call_childAbsent(oldChild, 'without_excuse');
        },
        deleteCurrentAbsence() {
            let oldChild = this.clone(this.child);
            this.deleteStatus('absent');
            this.addStatus('notHereYet');
            this.child.isAbsenceDeletable = false;
            this.call_deleteCurrentAbsence(oldChild);
        },
        deleteCheckoutTime() {
            let oldChild = this.clone(this.child);
            this.flipped = false;
            this.child.checkoutTime = this.child.hasRegularTime ? this.child.regularTimeEnd : this.getNowFormated();
            //@todo
            // this.child.updateCheckoutTimer = this.child.updateCheckoutTimer ? true : false;
            this.toggleStatus('present');
            this.toggleStatus('pickedUp');
            this.call_deleteCheckoutTime(oldChild);
        },
        checkoutNow() {
            if (!this.checkTimes(this.child) || !this.isValidTime) {
                return;
            }

            this.$emit('hide-pickup-permission');
            this.showAbsentLayer = false;
            let oldChild = this.clone(this.child);
            this.child.checkoutTime = this.getCurrentClock();
            this.child.updateCheckoutTimer = false;
            this.toggleStatus('present');
            this.toggleStatus('pickedUp');
            this.call_checkoutNow(oldChild);
        },
        checkOut() {
            if (!this.checkTimes(this.child) || !this.isValidTime) {
                return;
            }

            this.flipped = false;
            this.$emit('hide-pickup-permission');
            this.showAbsentLayer = false;
            let oldChild = this.clone(this.child);
            this.child.updateCheckoutTimer = false;
            this.toggleStatus('present');
            this.toggleStatus('pickedUp');
            this.call_checkout(oldChild);
        },
        change(action) {
            if (action !== 'checkin') {
                if (!this.checkTimes(this.child) || !this.isValidTime) {
                    return;
                }
            }
            let oldChild = this.clone(this.child);
            this.flipped = false;
            this.call_change(oldChild, action);
        },
        changeDescription() {
            let oldChild = this.clone(this.child);
            let today = moment().format('YYYY-MM-DD');
            this.call_updateDescription(oldChild, today);
        },
        handle_ajax_error(xhr, status, error, oldChild) {
            /**
                 * Die Fehlermeldungen funktionieren aktuell nicht korrekt. Da diese Card-Komponente beim Melden einer
                 * Anwesenheit direkt verschoben (d.h. entfernt) wird, funktioniert der Zugriff auf this.$t nicht.
                 * Da in der Eltern-Komponente allerdings auch kein :key definiert ist, "rutschen" die folgenden Karten
                 * nach und es wird die nachfolgende Komponente verwendet. Aus diesem Grund wurde auch der Workaround
                 * "oldChild" eingebaut.
                 * Siehe KIGAROO-6500
                 */
            this.$emit('hide-pickup-permission');
            this.errorCallback(oldChild);
            if ('timeout' === status) {
                this.show_info('infoBox', 'error', this.$t('Es ist ein Problem aufgetreten, bitte überprüfen Sie Ihre Online Verbindung und laden Sie die Seite bitte neu.'));
                $('.checkin_message_close').show();
                return;
            }
            if (403 === xhr.status) {
                this.show_info('infoBox', 'error', this.$t('Sie wurden aus Sicherheitsgründen ausgeloggt, bitte loggen Sie sich erneut ein.'));
                $('.checkin_message_login').show();
                return;
            }
            if (200 !== xhr.status) {
                if (oldChild) {
                    let message = this.$t('Die Daten für {name} konnten nicht gespeichert werden. Bitte wiederholen Sie den Vorgang.', {'name': oldChild.firstname + ' ' + oldChild.lastname});
                    this.show_info('infoBox', 'error', message);
                    $('.checkin_message_close').show();
                } else {
                    this.show_info('infoBox', 'error', this.$t('Es ist ein Fehler aufgetreten. Bitte laden Sie die Seite neu.'));
                    $('.checkin_message_close').show();
                }
                return;
            }
        },
        show_info(key, status, message) {
            $('#checkin_overlay').fadeIn();
            if (status === 'error') {
                $('#checkin_message_headline').html('<h3>' + this.$t('Achtung!') + '</h3>');
            }
            $('#checkin_message').html(message);
            $('.checkin_' + key).addClass(status).fadeIn().animate({
                'top': '70px'
            });
        },
        updateCheckinTime(checkinTime) {
            this.child.checkinTime = checkinTime;
            this.isValidTime = true;
        },
        updateCheckoutTime(checkoutTime) {
            this.child.checkoutTime = checkoutTime;
            this.isValidTime = true;
        },
        checkTimes(child) {
            const checkinTime = child.checkinTime;
            const checkoutTime = child.checkoutTime;

            if (!checkinTime || !checkoutTime) {
                return true;
            }

            this.isValidTime = moment(checkoutTime, 'HH:mm') > moment(checkinTime, 'HH:mm');
            if (!this.isValidTime) {
                this.show_info('infoBox', 'error', this.$t('Die Bringzeit muss vor der Abholzeit liegen.'));
                $('.checkin_message_close').show();
            }

            return this.isValidTime;
        },
    }
}
</script>

<style lang="scss" rel="stylesheet/scss">
.tabletView {
    .ui-timepicker td a {
        box-sizing: content-box;
    }

    .input-time {
        display: block !important;
        border: 0 solid lightgrey;
        width: 100% !important;
        background-color: transparent;
    }

    .greyed-out {
        -webkit-filter: grayscale(100%);
        filter: grayscale(100%);
    }

    .important {
        color: red;
    }
}
</style>
